import * as CommentActions from './comment.actions';
import { CommentDto, SupportedAggregateTypes } from '../../models/comment.model';

export interface CommentState {
  totalCounts: Map<string, number>;
  results: Map<string, CommentDto[]>;
  loading: Map<string, boolean>;
}

export const initialState: CommentState = {
  totalCounts: new Map<string, number>(),
  results: new Map<string, CommentDto[]>(),
  loading: new Map<string, boolean>(),
};

export function reducer(state = initialState, action: CommentActions.Actions): CommentState {
  switch (action.type) {
    case CommentActions.LOAD_COMMENTS_PAGE: {
      const loadCommentsPageAggregate: string = getReferencedAggregateIdentifier(action?.payload?.aggregateType, action?.payload?.aggregateId);
      const loadCommentsPageLoading: Map<string, boolean> = Object.assign({}, state.loading);
      loadCommentsPageLoading[loadCommentsPageAggregate] = true;
      const loadCommentsPageTotalCounts: Map<string, number> = Object.assign({}, state.totalCounts);
      return {
        ...state,
        loading: loadCommentsPageLoading,
        totalCounts: loadCommentsPageTotalCounts,
      };
    }
    case CommentActions.LOAD_COMMENTS_PAGE_FAILURE: {
      const loadCommentsPageFailedAggregate: string = getReferencedAggregateIdentifier(
        action?.payload?.request?.aggregateType,
        action?.payload?.request?.aggregateType
      );
      const loadCommentsPageFailedLoading: Map<string, boolean> = Object.assign({}, state.loading);
      loadCommentsPageFailedLoading[loadCommentsPageFailedAggregate] = true;
      const loadCommentsPageFailedTotalCounts: Map<string, number> = Object.assign({}, state.totalCounts);
      loadCommentsPageFailedTotalCounts[loadCommentsPageFailedAggregate] = 0;
      const loadCommentsPageFailedResults: Map<string, CommentDto[]> = Object.assign({}, state.results);
      loadCommentsPageFailedResults[loadCommentsPageFailedAggregate] = [];
      return {
        ...state,
        loading: loadCommentsPageFailedLoading,
        results: loadCommentsPageFailedResults,
        totalCounts: loadCommentsPageFailedTotalCounts,
      };
    }
    case CommentActions.LOAD_COMMENTS_PAGE_SUCCESS: {
      const loadCommentsPageSuccessAggregate: string = getReferencedAggregateIdentifier(
        action?.payload?.request?.aggregateType,
        action?.payload?.request?.aggregateId
      );

      const loadCommentsPageSuccessLoading: Map<string, boolean> = Object.assign({}, state.loading);
      loadCommentsPageSuccessLoading[loadCommentsPageSuccessAggregate] = false;
      const loadCommentsPageSuccessTotalCounts: Map<string, number> = Object.assign({}, state.totalCounts);
      loadCommentsPageSuccessTotalCounts[loadCommentsPageSuccessAggregate] = action?.payload?.response?.meta?.pagination?.total;
      const loadCommentsPageSuccessResults: Map<string, CommentDto[]> = Object.assign({}, state.results);
      let existingComments: CommentDto[] = [];
      if (!!action?.payload?.request?.autoLoadNextPage && action?.payload?.request?.offset > 0) {
        // update existing entries, because additional page loaded
        existingComments = loadCommentsPageSuccessResults[loadCommentsPageSuccessAggregate];
      }
      existingComments = existingComments.concat(action?.payload?.response?.data);
      loadCommentsPageSuccessResults[loadCommentsPageSuccessAggregate] = existingComments;

      return {
        ...state,
        loading: loadCommentsPageSuccessLoading,
        results: loadCommentsPageSuccessResults,
        totalCounts: loadCommentsPageSuccessTotalCounts,
      };
    }
    case CommentActions.WRITE_COMMENT_SUCCESS: {
      const writeCommentSuccessAggregate: string = getReferencedAggregateIdentifier(
        action?.payload?.response?.referencedAggregateType,
        action?.payload?.response?.referencedAggregateId
      );

      // update results
      console.log(writeCommentSuccessAggregate);
      const writeCommentsSuccessResults: Map<string, CommentDto[]> = Object.assign({}, state.results);
      let isUpdate = false;
      if (!writeCommentsSuccessResults[writeCommentSuccessAggregate]) {
        writeCommentsSuccessResults[writeCommentSuccessAggregate] = [];
      } else {
        writeCommentsSuccessResults[writeCommentSuccessAggregate] = Object.assign([], state?.results[writeCommentSuccessAggregate]);
        isUpdate =
          writeCommentsSuccessResults[writeCommentSuccessAggregate].filter(
            (c: CommentDto) => c?.aggregateId === action?.payload?.response?.aggregateId
          ).length > 0;
      }
      writeCommentsSuccessResults[writeCommentSuccessAggregate] = writeCommentsSuccessResults[writeCommentSuccessAggregate].filter(
        (c: CommentDto) => c?.aggregateId !== action?.payload?.response?.aggregateId
      );
      writeCommentsSuccessResults[writeCommentSuccessAggregate].push(action?.payload?.response);
      writeCommentsSuccessResults[writeCommentSuccessAggregate].sort((a: CommentDto, b: CommentDto) =>
        new Date(a.updatedAt) > new Date(b.updatedAt) ? -1 : 1
      );

      // determine whether to increase totalCount or not
      const writeCommentsSuccessTotalCounts: Map<string, number> = Object.assign({}, state.totalCounts);
      if (!writeCommentsSuccessTotalCounts[writeCommentSuccessAggregate]) writeCommentsSuccessTotalCounts[writeCommentSuccessAggregate] = 0;
      if (!isUpdate) writeCommentsSuccessTotalCounts[writeCommentSuccessAggregate] += 1;

      return {
        ...state,
        results: writeCommentsSuccessResults,
        totalCounts: writeCommentsSuccessTotalCounts,
      };
    }
    case CommentActions.DELETE_COMMENT_SUCCESS: {
      const deleteCommentSuccessAggregate: string = getReferencedAggregateIdentifier(
        action?.payload?.request?.referencedAggregateType,
        action?.payload?.request?.referencedAggregateId
      );
      const deleteCommentsSuccessResults: Map<string, CommentDto[]> = Object.assign({}, state.results);
      if (!deleteCommentsSuccessResults[deleteCommentSuccessAggregate]) {
        deleteCommentsSuccessResults[deleteCommentSuccessAggregate] = [];
      } else {
        //                deleteCommentsSuccessResults[deleteCommentSuccessAggregate] = Object.assign([], state?.results[deleteCommentSuccessAggregate]);
        deleteCommentsSuccessResults[deleteCommentSuccessAggregate] = state?.results[deleteCommentSuccessAggregate].filter(
          c => c.aggregateId !== action?.payload?.request?.aggregateId
        );
      }

      const deleteCommentsSuccessTotalCounts: Map<string, number> = Object.assign({}, state.totalCounts);
      if (!deleteCommentsSuccessTotalCounts[deleteCommentSuccessAggregate]) {
        deleteCommentsSuccessTotalCounts[deleteCommentSuccessAggregate] = 0;
      } else {
        deleteCommentsSuccessTotalCounts[deleteCommentSuccessAggregate] -= 1;
        if (deleteCommentsSuccessTotalCounts[deleteCommentSuccessAggregate] < 0) deleteCommentsSuccessTotalCounts[deleteCommentSuccessAggregate] = 0;
      }

      return {
        ...state,
        results: deleteCommentsSuccessResults,
        totalCounts: deleteCommentsSuccessTotalCounts,
      };
    }
    default:
      return state;
  }
}

/**
 *
 */
export function getReferencedAggregateIdentifier(referencedAggregateType: SupportedAggregateTypes, referencedAggregateId) {
  if (!referencedAggregateId || !referencedAggregateType) return null;
  return referencedAggregateType?.toString().toLowerCase() + ':' + referencedAggregateId;
}

export const totalCounts = (state: CommentState) => state?.totalCounts;
export const results = (state: CommentState) => state?.results;
export const loading = (state: CommentState) => state?.loading;
